import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { Controller, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { NameError, Categories, Description, EditCategory, Name, Save, Type, Image } from "../../../Constant";
import SpinnerLoader from "../../../Layout/SpinnerLoader";
import { updateCategory, updateCategoryRole, viewCategory, viewCategoryRole } from "../../../CommonUrl";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { useSelector } from "react-redux";
import Typeahead from "../../../CommonElements/TypeAhead";
import Transparentspinner from "../../Common/Loader/Transparentspinner";

const CategoryEdit = () => {

    const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
        defaultValues: {}
    });
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const authState = useSelector((state) => state.auth);
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const param1 = params.get("id");
    const form = new FormData();
    const [selectedType, setSelectedType] = useState('');
    const [image, setImage] = useState('');
    const [imagePreview, setImagePreview] = useState('');


    const options = [
        { value: "expense", label: "Expense" },
        { value: "income", label: "Income" },
        { value: "item", label: "Item" },
        { value: "other", label: "Other" },
    ];
    const navigate = useNavigate();

    useEffect(() => {
        getCategory();
    }, []);

    const handleLogoChange = (event) => {
        const selectedFile = event.target.files[0];
        setImage(selectedFile);
        if (selectedFile) {
            setImagePreview(URL.createObjectURL(selectedFile)); // preview
        }

    }

    const getCategory = async () => {
        setLoading(true);
        let data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewCategory + `?category_id=${param1}` : viewCategoryRole + `?category_id=${param1}`);
        if (data.status === true) {
            console.log(data)
            setValue('name', data.data[0].name);
            setValue('type', { label: data.data[0].type,value: data.data[0].type });
            setSelectedType(data.data[0].type);
            setImage(data?.data[0]?.imageUrl)
            setImagePreview(data?.data[0]?.imageUrl)
        }
        else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
        else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    }


    const onSubmit = async (data) => {
        setLoading(true);
        form.append("name", data.name);
        form.append("type", data?.type?.value);
        form.append('category_id', param1)
        if (data.type.value === 'item' && data.image && data.image[0]) {
            form.append("image", data.image[0]);
        }
        const editCategoryResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? updateCategory : updateCategoryRole, form, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        if (editCategoryResponse.status === 200) {
            if (editCategoryResponse.data.status === true) {
                toast.success('Success...!')
                navigate(`${process.env.PUBLIC_URL}/settings/categories`);
            } else {
                toast.error(editCategoryResponse.data.message)
                setLoading(false);
            }
        } else if (editCategoryResponse.status >= 400 && editCategoryResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (editCategoryResponse.status >= 500 && editCategoryResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}
            <Breadcrumbs mainTitle={Categories} parent="Settings" title={Categories} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{EditCategory}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="name">{Name} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="name" type="text" {...register('name', { required: true })} />
                                <span className="text-danger">{errors.name && NameError}</span>
                            </Col>
                            <Col md="6">
                                <Label className="form-label">{Type} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="type"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={options}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                setSelectedType(value?.value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <span className="text-danger">{errors.industry && IndustryError}</span>
                            </Col>
                        </Row>
                        <FormGroup>
                        </FormGroup>
                        {selectedType === 'item' && (
                            <Row>
                                <Col md="6">
                                    <Label className="form-label">{Image}</Label>
                                    <Controller
                                        name="image"
                                        control={control}
                                        render={({ field }) => (
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Col md="8">
                                                    <input
                                                        {...register("image")}
                                                        className="form-control fileInputStyle"
                                                        type="file"
                                                        onChange={handleLogoChange}
                                                        accept=".png, .jpg, .jpeg"
                                                    />
                                                </Col>
                                                <Col md='4'>
                                                    <span className="imagestyle">
                                                        {image && <img src={(imagePreview)} alt="logo" width="40px" height="40px" />}
                                                    </span>
                                                </Col>
                                            </div>
                                        )}
                                    />
                                    <span className="text-danger">{errors.logo && "logo is required"}</span>
                                </Col>
                            </Row>
                        )}
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default CategoryEdit;
